import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Image } from 'semantic-ui-react';
import { Button as Btn } from 'components';

import classNames from 'classnames/bind';
import styles from './StartExam.css';
const cx = classNames.bind(styles);

// buttonColor - 헥스 컬러로 넘겨 받은 색상을 버튼에 적용 (ex> buttonColor="a52f01")
// fullColor - 버튼의 배경을 투명하게 할지 꽉채울지 (default:투명 배경 1: 배경 채우기)
// fontSize - 글씨 크기 설정 (숫자 형태로 넘기면 됨 ex> fontSize="14")

class StartExamWizardButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      invalid,
      loading,
      step,
      disableNext,
      handleGoNext,
      handleGoPrevious,
      handleOnToggleModal,
      stepCount
    } = this.props;

    return (
      <div className={cx('bt-startExam-step-area')}>
        {step > 1 &&
          step !== stepCount && (
            <Btn
              className={cx('bt-startExam-step bt-prev')}
              buttonColor="#69a89b"
              buttonType="material"
              // loading={loading}
              disabled={loading}
              onClick={handleGoPrevious}>
              <Image src={'/img/examStart/btn_prev.png'} />
              {defineMessages(formatMessage({ id: 'StartExamWizardButton_1', defaultMessage: '이 전' }))}
            </Btn>
          )}
        {step < stepCount - 1 && (
          // invalid 는 보여지고 있는 필드(count > 0)에 대해서만 계산됨
          <Btn
            className={cx('bt-startExam-step')}
            buttonColor="#11a991"
            fullColor
            buttonType="material"
            // loading={loading}
            disabled={(disableNext && invalid) || loading}
            onClick={handleGoNext}>
            {defineMessages(formatMessage({ id: 'StartExamWizardButton_2', defaultMessage: '다 음' }))}
            <Image src={'/img/examStart/btn_next.png'} />
          </Btn>
        )}
        {step === stepCount - 1 && (
          // invalid 는 보여지고 있는 필드(count > 0)에 대해서만 계산됨
          <Btn
            className={cx('bt-startExam-step')}
            buttonColor="#11a991"
            fullColor
            buttonType="material"
            // loading={loading}
            disabled={(disableNext && invalid) || loading}
            onClick={handleGoNext}>
            {defineMessages(formatMessage({ id: 'StartExamWizardButton_3', defaultMessage: '실 행' }))}
            <Image src={'/img/examStart/btn_next.png'} />
          </Btn>
        )}
        {step === stepCount && (
          <Btn
            className={cx('bt-startExam-step')}
            buttonColor="#11a991"
            fullColor
            buttonType="material"
            onClick={handleOnToggleModal}>
            {defineMessages(formatMessage({ id: 'StartExamWizardButton_4', defaultMessage: '확 인' }))}
          </Btn>
        )}
      </div>
    );
  }
}

StartExamWizardButton.propTypes = {
  step: PropTypes.number
};
StartExamWizardButton.defaultProps = {
  step: 1
};

export default injectIntl(StartExamWizardButton);



// WEBPACK FOOTER //
// ./src/script/components/exam-start/StartExamWizardButton.js